<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
  >
    <template v-slot:activator="{ on }">
      <a
        href="javascript:;"
        v-on="on"
      >{{ text }}</a>
    </template>
    <v-card>
      <div
        class="pa-4 text-h6"
      >
        {{ $t('Outbox.eDocX.Status') }}
      </div>
      <div
        v-if="showResendBtn"
        align="center"
      >
        <v-btn
          color="primary"
          :loading="calling"
          @click="resendToEdocx"
        >
          {{ $t('Outbox.eDocX.Resend') }}
        </v-btn>
      </div>
      <v-simple-table>
        <tbody>
          <tr
            v-for="(item,i) in eDocXStatus"
            :key="i"
          >
            <td style="width: 30%">
              {{ item.entityAbbr }} - {{ $chPtObjData('entityChinName', item) }} :
            </td>
            <td>
              {{ $t(eDocXi18nPrefix+item.status) }}
            </td>
            <td>
              {{ item.date }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import outboxApi from '@/api/outbox/outbox'
import { isArrayEmptyOrNull } from '@/utils/arrayUtil'
import { EDOCX_I18N_PREFIX } from '@/constant/constant'

export default {
  props: {
    text: {
      type: String,
      required: true
    },
    approverEuid: {
      type: String,
      required: true
    },
    oficioId: {
      type: Number,
      required: true
    },
    isUrgent: {
      type: Boolean,
      required: true
    },
    isDirectSendToEdocx: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      dialog: false,
      calling: false,
      eDocXi18nPrefix: EDOCX_I18N_PREFIX,
      eDocXStatus: [],
      showResendBtn: false
    }
  },
  watch: {
    dialog: function (val) {
      if (val) {
        this.getOficioEDocXStatus()
      }
    }
  },
  created () {
  },
  methods: {
    getOficioEDocXStatus () {
      this.calling = true
      outboxApi.oficioEDocXStatus_v2(this.oficioId, resp => {
        this.calling = false
        if (resp.status === 201 || resp.status === 200) {
          this.eDocXStatus = resp.data
          this.showResendBtn = isArrayEmptyOrNull(this.eDocXStatus)
        }
      })
    },
    resendToEdocx () {
      this.calling = true
      outboxApi.callEDocXApiViaUI(this.approverEuid, this.oficioId, this.isUrgent, this.isDirectSendToEdocx, resp => {
        this.calling = false
        if (resp.status === 201 || resp.status === 200) {
          this.getOficioEDocXStatus()
        }
      })
    }
  }
}
</script>
